const languages = [`en`, `de`, `el`, `es`, `da`, `fi`, `fr`, `it`, `ja`, `ko`, `nb`, `nl`, `pl`, `pt`, `ru`, `sv`, `tr`];
const defaultLanguage = process.env.GATSBY_DEFAULT_LANG;

const getRedirectLanguage = () => {
  if (typeof navigator === `undefined`) {
    return process.env.GATSBY_DEFAULT_LANG;
  }

  const lang =
    navigator && navigator.language && navigator.language.split("-")[0];
  if (!lang) return defaultLanguage;

  if (languages.includes(lang)) {
    return lang;
  }

  return defaultLanguage;
};

exports.defaultLanguage = defaultLanguage;
exports.languages = languages;
exports.getRedirectLanguage = getRedirectLanguage;
